(() => {
  if (window.__lmcdSpiralVideoScript) return;
  window.__lmcdSpiralVideoScript = true;
  const initialize = (root) => {
    if (root.dataset.spiralVideoReady === 'true') return;
    root.dataset.spiralVideoReady = 'true';
    const videos = [...root.querySelectorAll('video')];
    const cleanup = [];
    const listen = (node, event, handler) => {
      node.addEventListener(event, handler);
      cleanup.push(() => node.removeEventListener(event, handler));
    };
    const syncSound = (video) => {
      // Native volume changes also keep the separate sound button accurate.
      const button = video.closest('figure')?.querySelector('[data-spiral-video-sound]');
      if (!button) return;
      button.textContent = video.muted ? 'Tap for sound' : 'Mute video';
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', video.muted ? 'Unmute product video' : 'Mute product video');
    };
    const silenceOthers = (current) => videos.forEach((other) => {
      if (other === current) return;
      other.pause();
      other.muted = true;
      syncSound(other);
    });
    const thumbs = [...root.querySelectorAll('[data-spiral-thumb]')];
    for (const [selector, step] of [['[data-spiral-gallery-prev]', -1], ['[data-spiral-gallery-next]', 1]]) {
      root.querySelectorAll(selector).forEach((button) => listen(button, 'click', () => {
        const current = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
        thumbs[(current + step + thumbs.length) % thumbs.length]?.click();
      }));
    }
    videos.forEach((video) => {
      video.muted = true;
      syncSound(video);
      const sound = video.closest('figure')?.querySelector('[data-spiral-video-sound]');
      if (sound) listen(sound, 'click', () => {
        silenceOthers(video);
        video.muted = !video.muted;
        syncSound(video);
        if (video.paused) video.play().catch(() => {});
      });
      listen(video, 'play', () => silenceOthers(video));
      listen(video, 'volumechange', () => {
        if (!video.muted) silenceOthers(video);
        syncSound(video);
      });
      // Keep native seeking and volume gestures out of the gallery swipe handler.
      for (const event of ['pointerdown', 'pointerup']) {
        listen(video, event, (input) => input.stopPropagation());
        if (sound) listen(sound, event, (input) => input.stopPropagation());
      }
    });
    root.__spiralVideoTeardown = () => {
      cleanup.splice(0).forEach((remove) => remove());
      videos.forEach((video) => { video.pause(); video.muted = true; });
      delete root.dataset.spiralVideoReady;
    };
  };
  const boot = () => document.querySelectorAll('[data-spiral-video-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', ({ target }) => {
    if (target.matches?.('[data-spiral-video-root]')) target.__spiralVideoTeardown?.();
    target.querySelectorAll?.('[data-spiral-video-root]').forEach((root) => root.__spiralVideoTeardown?.());
  });
})();
